/**
 * exportacoesApi — chamadas à API de Exportação (M9) sobre o ApiClient base.
 *
 * POST /exportacoes → { exportacaoId, status, formato } (topo)
 * GET  /exportacoes → { data: [...], nextCursor } (topo)
 * GET  /exportacoes/{id} → detalhe (topo)
 * GET  /exportacoes/{id}/download → { downloadUrl, expiresIn } (topo)
 *
 * Nenhum dado pessoal é logado (RN-M11-001). O JWT é anexado pelo ApiClient.
 */

import { ApiClient } from './apiClient';
import {
  CriarExportacaoInput,
  CriarExportacaoResponse,
  DownloadExportacao,
  ExportacaoDetalhe,
  ExportacaoListItem,
} from './exportacoes-types';

interface EnvelopeLista<T> {
  readonly data: readonly T[];
  readonly nextCursor: string | null;
}

/** Página de lista já no formato consumido pelos hooks. */
export interface PaginaExportacoes {
  readonly itens: readonly ExportacaoListItem[];
  readonly nextCursor: string | null;
}

export class ExportacoesApi {
  constructor(private readonly client: ApiClient) {}

  /** POST /exportacoes — solicita a exportação. */
  async criar(input: CriarExportacaoInput): Promise<CriarExportacaoResponse> {
    return this.client.request<CriarExportacaoResponse>('/exportacoes', {
      method: 'POST',
      body: JSON.stringify(input),
    });
  }

  /** GET /exportacoes — lista paginada das exportações do usuário. */
  async listar(cursor?: string): Promise<PaginaExportacoes> {
    const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
    const resp = await this.client.request<EnvelopeLista<ExportacaoListItem>>(
      `/exportacoes${query}`,
    );
    return { itens: resp.data, nextCursor: resp.nextCursor };
  }

  /** GET /exportacoes/{id} — status/metadados de uma exportação. */
  async obter(id: string): Promise<ExportacaoDetalhe> {
    return this.client.request<ExportacaoDetalhe>(`/exportacoes/${encodeURIComponent(id)}`);
  }

  /** GET /exportacoes/{id}/download — URL pré-assinada (15 min). */
  async baixar(id: string): Promise<DownloadExportacao> {
    return this.client.request<DownloadExportacao>(
      `/exportacoes/${encodeURIComponent(id)}/download`,
    );
  }
}
